import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { PayableService } from '@univacity/angular/datas';
import { Payable } from '@univacity/shared/types';

import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PayablesResolver implements Resolve<Observable<Payable[]>> {
  constructor(private svc: PayableService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Payable[]> {
    return this.svc
      .find({
        ...route.queryParams,
        populate: [
          'organisation.name',
          'organisation.logo',
          'organisation.isPartner',
          'organisation.currency',
        ],
        organisation: route.params['id'],
      })
      .pipe(map((res) => res.docs));
  }
}
